import { useLocation, useNavigate } from "react-router-dom";
import { StyledBar, StyledButton } from "./lower-menu-bat.style";
import { Dayjs } from "dayjs";
import { useSelectedDate } from "../../../shared/hooks/use-selected-date";

export const LowerMenuBar = () => {
  const navigate = useNavigate();

  const selectedDate: Dayjs = useSelectedDate();

  const onClick = (path: string) => {
    navigate(`/${path}/?date=${JSON.stringify(selectedDate)}`);
  };
  
  return (
    <StyledBar>
      <StyledButton onClick={() => onClick('year-events')}>У гэтым годзе спаўняецца...</StyledButton>
    </StyledBar>
  );
};

